import { Injectable } from '@angular/core';
import { TransferStatus } from '../../../../../../XpressTransfer/app/transfer/components/transfer/shared/enums/transfer-status.enum';
import { XpressClientLocationTypeEnum } from 'app/models';
import { XpassStatusLabels } from '../enums/xpass-status-labels.enum';
import { XpassLocationLabels } from '../enums/xpass-location-labels.enum';
import { XpassProductLabels } from '../enums/xpass-product-labels.enum';
import { XpassProduct } from '../enums/xpass-product.enum';
import { TransferTripType } from '../enums/transfer-trip-type.enum';
import { XpassTripTypeLabels } from '../enums/xpass-trip-type-labels.enum';
import { TransferTripTypeModel } from '../models/transfer-trip-type.model';

@Injectable({
  providedIn: 'root',
})
export class CommonTypeService {
  formatStatusIntoLabel(status: TransferStatus): XpassStatusLabels {
    switch (status) {
      case TransferStatus.Paid:
        return XpassStatusLabels.CONFIRMED;

      case TransferStatus.TricycleTransfer:
      case TransferStatus.WaitTricycle:
        return XpassStatusLabels.TRICYCLE;

      case TransferStatus.BoatTransfer:
        return XpassStatusLabels.BOAT;

      case TransferStatus.ETrikeTransfer:
        return XpassStatusLabels.ETRIKE;

      case TransferStatus.Completed:
        return XpassStatusLabels.COMPLETED;

      case TransferStatus.Cancelled:
        return XpassStatusLabels.CANCELLED;

      default:
        return XpassStatusLabels.CANCELLED;
    }
  }

  formatLocationIntoLabel(
    location: XpressClientLocationTypeEnum
  ): XpassLocationLabels {
    switch (location) {
      case XpressClientLocationTypeEnum.Boracay:
        return XpassLocationLabels.BORACAY;
      case XpressClientLocationTypeEnum.ElNido:
        return XpassLocationLabels.EL_NIDO;
      default:
        return XpassLocationLabels.BORACAY;
    }
  }

  formatProductIntoLabel(product: XpassProduct): XpassProductLabels {
    switch (product) {
      case XpassProduct.STRESS_FREE:
        return XpassProductLabels.STRESS_FREE;

      case XpassProduct.GOVT_FEE:
        return XpassProductLabels.GOVT_FEE;

      case XpassProduct.CONCIERGE:
        return XpassProductLabels.CONCIERGE;

      default:
        return XpassProductLabels.CONCIERGE;
    }
  }

  formatLabelIntoLocation(label: string): XpressClientLocationTypeEnum | undefined {
    const locationValues = [XpressClientLocationTypeEnum.Boracay, XpressClientLocationTypeEnum.ElNido];
    return locationValues.find(loc => this.formatLocationIntoLabel(loc) === label);
  }

  formatLabelIntoProduct(label: string): XpassProduct | undefined {
    const productValues = [XpassProduct.STRESS_FREE, XpassProduct.GOVT_FEE, XpassProduct.CONCIERGE];
    return productValues.find(prod => this.formatProductIntoLabel(prod) === label);
  }

  formatLabelIntoStatus(label: string): TransferStatus | undefined {
    const statusValues = [
      TransferStatus.Paid,
      TransferStatus.TricycleTransfer,
      TransferStatus.WaitTricycle,
      TransferStatus.BoatTransfer,
      TransferStatus.ETrikeTransfer,
      TransferStatus.Completed,
      TransferStatus.Cancelled
    ];
    return statusValues.find(status => this.formatStatusIntoLabel(status) === label);
  }

  formatTripTypeIntoLabel(tripType?: TransferTripType): XpassTripTypeLabels {
    switch (tripType) {
      case TransferTripType.ArrivalOnlyTrip:
        return XpassTripTypeLabels.ARRIVAL;
      case TransferTripType.DepartureOnlyTrip:
        return XpassTripTypeLabels.DEPARTURE;
      case TransferTripType.RoundTrip:
        return XpassTripTypeLabels.ROUND_TRIP;
      default:
        return XpassTripTypeLabels.NONE;
    }
  }

  formatLabelIntoTripType(label: string): TransferTripType | undefined {
    const tripType = TransferTripTypeModel.TransferTripTypeList.find(
      (option) => option.name === label
    );
    return tripType?.value;
  }
}
